/* Bild-Zoom fuer die Theme-Galerie auf der Produktseite.
   Gilt fuer Produkte ohne die App "Variant Image Module" (VIM) – dort bringt VIM
   einen eigenen Zoom mit, und die Theme-Galerie ist ausgeblendet.
   Klick aufs Bild oder auf die Lupe oeffnet eine Vollbild-Ansicht:
   Klick/Tipp = zoomen, ziehen = verschieben, Mausrad/Zwei-Finger = stufenlos,
   Wischen/Pfeile = blaettern, Esc = schliessen.
   Die hochaufloesende Bild-URL kommt aus data-gz-zoom (sections/product-data.liquid).
   Stand: 25.09.2026 */
(function () {
  'use strict';

  var MAX_ZOOM = 4;
  var T = (window.gzBilderZoom && window.gzBilderZoom.texte) || {
    dialog: 'Bildergalerie',
    oeffnen: 'Bild vergrößern',
    schliessen: 'Schließen',
    zurueck: 'Vorheriges Bild',
    weiter: 'Nächstes Bild',
    bild: 'Bild'
  };

  var ICON_LUPE = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21M10.5 7.5v6M7.5 10.5h6"/></svg>';
  var ICON_X = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var ICON_L = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_R = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  var galerie = null;
  var eintraege = [];
  var box, buehne, bild, zaehler, leiste, btnSchliessen, btnZurueck, btnWeiter;
  var index = 0, s = 1, tx = 0, ty = 0;
  var offen = false, ausloeser = null, ladeNr = 0;
  var zeiger = {}, geste = null, klickStart = null, alterOverflow = '';

  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function sammeln() {
    var ersteSlide = document.querySelector('.product-media-main .swiper-slide[data-gz-zoom]');
    if (!ersteSlide) return false;
    galerie = ersteSlide.closest('.product-media-main');
    eintraege = [];
    var slides = galerie.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide');
    for (var i = 0; i < slides.length; i++) {
      var sl = slides[i];
      if (!sl.hasAttribute('data-gz-zoom')) continue;
      var img = sl.querySelector('img');
      eintraege.push({
        slide: sl,
        swiperIndex: i,
        src: sl.getAttribute('data-gz-zoom'),
        w: parseInt(sl.getAttribute('data-gz-w'), 10) || 1000,
        h: parseInt(sl.getAttribute('data-gz-h'), 10) || 1000,
        alt: img ? img.alt : ''
      });
    }
    return eintraege.length > 0;
  }

  function vorschauVon(e) {
    var img = e.slide.querySelector('img');
    if (img && img.classList.contains('lazyloaded') && (img.currentSrc || img.src)) return img.currentSrc || img.src;
    return e.src;
  }

  function miniVon(e) {
    return e.src.replace(/([?&])width=\d+/, '$1width=160');
  }

  /* ---------- Aufbau ---------- */

  function bauen() {
    box = document.createElement('div');
    box.className = 'gz-zoom';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', T.dialog);
    box.innerHTML =
      '<div class="gz-zoom__kopf">' +
        '<span class="gz-zoom__zaehler" aria-live="polite"></span>' +
        '<button type="button" class="gz-zoom__knopf gz-zoom__schliessen" aria-label="' + esc(T.schliessen) + '">' + ICON_X + '</button>' +
      '</div>' +
      '<div class="gz-zoom__buehne"><img class="gz-zoom__bild" alt="" draggable="false"></div>' +
      '<button type="button" class="gz-zoom__knopf gz-zoom__pfeil gz-zoom__pfeil--zurueck" aria-label="' + esc(T.zurueck) + '">' + ICON_L + '</button>' +
      '<button type="button" class="gz-zoom__knopf gz-zoom__pfeil gz-zoom__pfeil--weiter" aria-label="' + esc(T.weiter) + '">' + ICON_R + '</button>' +
      '<div class="gz-zoom__leiste"></div>';
    document.body.appendChild(box);

    buehne = box.querySelector('.gz-zoom__buehne');
    bild = box.querySelector('.gz-zoom__bild');
    zaehler = box.querySelector('.gz-zoom__zaehler');
    leiste = box.querySelector('.gz-zoom__leiste');
    btnSchliessen = box.querySelector('.gz-zoom__schliessen');
    btnZurueck = box.querySelector('.gz-zoom__pfeil--zurueck');
    btnWeiter = box.querySelector('.gz-zoom__pfeil--weiter');

    btnSchliessen.addEventListener('click', schliessen);
    btnZurueck.addEventListener('click', function () { blaettern(-1); });
    btnWeiter.addEventListener('click', function () { blaettern(1); });
    leiste.addEventListener('click', function (e) {
      var b = e.target.closest('[data-i]');
      if (b) zeigen(parseInt(b.getAttribute('data-i'), 10));
    });

    buehne.addEventListener('pointerdown', zeigerRunter);
    buehne.addEventListener('pointermove', zeigerBewegt);
    buehne.addEventListener('pointerup', zeigerHoch);
    buehne.addEventListener('pointercancel', zeigerHoch);
    buehne.addEventListener('wheel', mausrad, { passive: false });
    window.addEventListener('resize', function () { if (offen) { einpassen(); begrenzen(); anwenden(); } });
  }

  function leisteFuellen() {
    var html = '';
    if (eintraege.length > 1) {
      for (var i = 0; i < eintraege.length; i++) {
        html += '<button type="button" class="gz-zoom__mini" data-i="' + i + '" aria-label="' + esc(T.bild + ' ' + (i + 1)) + '">' +
          '<img src="' + esc(miniVon(eintraege[i])) + '" alt="" loading="lazy"></button>';
      }
    }
    leiste.innerHTML = html;
    box.classList.toggle('gz-zoom--einzeln', eintraege.length < 2);
  }

  /* ---------- Oeffnen / Schliessen / Blaettern ---------- */

  function oeffnen(i, von) {
    if (!box) bauen();
    document.body.appendChild(box); /* ans Ende, damit Siegel/Chat-Widgets darunter liegen */
    leisteFuellen();
    ausloeser = von || null;
    box.hidden = false;
    offen = true;
    alterOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', taste);
    zeigen(i);
    btnSchliessen.focus();
  }

  function schliessen() {
    if (!offen) return;
    offen = false;
    box.hidden = true;
    document.documentElement.style.overflow = alterOverflow;
    document.removeEventListener('keydown', taste);
    var sw = galerie && galerie.swiper;
    if (sw && typeof sw.slideTo === 'function') sw.slideTo(eintraege[index].swiperIndex, 0);
    if (ausloeser && typeof ausloeser.focus === 'function') ausloeser.focus();
  }

  function blaettern(richtung) {
    if (eintraege.length < 2) return;
    zeigen((index + richtung + eintraege.length) % eintraege.length);
  }

  function zeigen(i) {
    index = i;
    var e = eintraege[i];
    s = 1; tx = 0; ty = 0;
    box.classList.remove('gz-zoom--animiert');
    bild.alt = e.alt;
    einpassen();
    anwenden();

    var nr = ++ladeNr;
    bild.src = vorschauVon(e);
    if (bild.src !== e.src) {
      var hoch = new Image();
      hoch.onload = function () { if (nr === ladeNr) bild.src = e.src; };
      hoch.src = e.src;
    }

    zaehler.textContent = eintraege.length > 1 ? (i + 1) + ' / ' + eintraege.length : '';
    var minis = leiste.querySelectorAll('.gz-zoom__mini');
    for (var k = 0; k < minis.length; k++) {
      if (k === i) {
        minis[k].setAttribute('aria-current', 'true');
        minis[k].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      } else {
        minis[k].removeAttribute('aria-current');
      }
    }
  }

  /* ---------- Zoom-Mathematik ---------- */

  function einpassen() {
    var e = eintraege[index];
    var W = buehne.clientWidth, H = buehne.clientHeight;
    var r = Math.min(W / e.w, H / e.h);
    bild.style.width = Math.round(e.w * r) + 'px';
    bild.style.height = Math.round(e.h * r) + 'px';
  }

  function zielZoom() {
    var e = eintraege[index];
    var echt = Math.min(e.w, 2400) / (bild.offsetWidth || 1);
    return Math.max(2, Math.min(MAX_ZOOM, echt));
  }

  function begrenzen() {
    var mx = Math.max(0, (bild.offsetWidth * s - buehne.clientWidth) / 2);
    var my = Math.max(0, (bild.offsetHeight * s - buehne.clientHeight) / 2);
    tx = Math.min(mx, Math.max(-mx, tx));
    ty = Math.min(my, Math.max(-my, ty));
  }

  function anwenden() {
    bild.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + s + ')';
    buehne.classList.toggle('ist-gezoomt', s > 1);
  }

  /* Punkt relativ zur Buehnenmitte */
  function mitte(x, y) {
    var r = buehne.getBoundingClientRect();
    return { x: x - r.left - r.width / 2, y: y - r.top - r.height / 2 };
  }

  function zoomAuf(neu, p) {
    neu = Math.max(1, Math.min(MAX_ZOOM, neu));
    tx = p.x - (p.x - tx) * (neu / s);
    ty = p.y - (p.y - ty) * (neu / s);
    s = neu;
    if (s <= 1.01) { s = 1; tx = 0; ty = 0; }
    begrenzen();
  }

  function umschalten(x, y) {
    box.classList.add('gz-zoom--animiert');
    if (s > 1) { s = 1; tx = 0; ty = 0; }
    else zoomAuf(zielZoom(), mitte(x, y));
    anwenden();
  }

  /* ---------- Maus, Touch, Tastatur ---------- */

  function abstand(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }

  function zeigerRunter(e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    buehne.setPointerCapture(e.pointerId);
    zeiger[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(zeiger);
    box.classList.remove('gz-zoom--animiert');
    if (ids.length === 1) {
      geste = { typ: 'eins', sx: e.clientX, sy: e.clientY, tx0: tx, ty0: ty, bewegt: false };
    } else if (ids.length === 2) {
      var a = zeiger[ids[0]], b = zeiger[ids[1]];
      geste = { typ: 'zwei', d0: abstand(a, b), s0: s, tx0: tx, ty0: ty,
        m0: mitte((a.x + b.x) / 2, (a.y + b.y) / 2) };
    }
  }

  function zeigerBewegt(e) {
    if (!zeiger[e.pointerId] || !geste) return;
    zeiger[e.pointerId] = { x: e.clientX, y: e.clientY };
    if (geste.typ === 'eins') {
      var dx = e.clientX - geste.sx, dy = e.clientY - geste.sy;
      if (Math.abs(dx) + Math.abs(dy) > 6) geste.bewegt = true;
      if (!geste.bewegt) return;
      buehne.classList.add('ist-ziehen');
      if (s > 1) {
        tx = geste.tx0 + dx; ty = geste.ty0 + dy;
        begrenzen();
      } else if (eintraege.length > 1) {
        tx = dx; ty = 0;
      }
      anwenden();
    } else if (geste.typ === 'zwei') {
      var ids = Object.keys(zeiger);
      if (ids.length < 2) return;
      var a = zeiger[ids[0]], b = zeiger[ids[1]];
      var neu = Math.max(1, Math.min(MAX_ZOOM, geste.s0 * abstand(a, b) / (geste.d0 || 1)));
      var m = mitte((a.x + b.x) / 2, (a.y + b.y) / 2);
      tx = m.x - (geste.m0.x - geste.tx0) * (neu / geste.s0);
      ty = m.y - (geste.m0.y - geste.ty0) * (neu / geste.s0);
      s = neu;
      begrenzen();
      anwenden();
    }
  }

  function zeigerHoch(e) {
    if (!zeiger[e.pointerId]) return;
    delete zeiger[e.pointerId];
    buehne.classList.remove('ist-ziehen');
    var rest = Object.keys(zeiger);
    if (!geste) return;

    if (geste.typ === 'zwei') {
      if (rest.length === 1) {
        var p = zeiger[rest[0]];
        geste = { typ: 'eins', sx: p.x, sy: p.y, tx0: tx, ty0: ty, bewegt: true };
      } else {
        geste = null;
      }
      if (s < 1.05) { box.classList.add('gz-zoom--animiert'); s = 1; tx = 0; ty = 0; anwenden(); }
      return;
    }

    if (e.type === 'pointercancel') { geste = null; return; }

    var dx = e.clientX - geste.sx;
    if (!geste.bewegt) {
      umschalten(e.clientX, e.clientY);
    } else if (s === 1) {
      box.classList.add('gz-zoom--animiert');
      if (dx < -50) blaettern(1);
      else if (dx > 50) blaettern(-1);
      else { tx = 0; anwenden(); }
    }
    geste = null;
  }

  function mausrad(e) {
    e.preventDefault();
    box.classList.remove('gz-zoom--animiert');
    zoomAuf(s * Math.exp(-e.deltaY * 0.0015), mitte(e.clientX, e.clientY));
    anwenden();
  }

  function taste(e) {
    if (e.key === 'Escape') { e.preventDefault(); schliessen(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); blaettern(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); blaettern(1); }
    else if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(box.querySelectorAll('button'), function (b) { return b.offsetParent !== null; });
      if (!f.length) return;
      var erst = f[0], letzt = f[f.length - 1];
      if (e.shiftKey && document.activeElement === erst) { e.preventDefault(); letzt.focus(); }
      else if (!e.shiftKey && document.activeElement === letzt) { e.preventDefault(); erst.focus(); }
      else if (!box.contains(document.activeElement)) { e.preventDefault(); erst.focus(); }
    }
  }

  /* ---------- Einstieg aus der Galerie ---------- */

  /* Capture-Phase: laeuft vor dem Theme-Handler in application.js, der beim Klick aufs
     Bild nur zum naechsten Bild blaettert. Nach einem Wisch (Swiper) bleibt es beim Blaettern. */
  document.addEventListener('pointerdown', function (e) {
    klickStart = { x: e.clientX, y: e.clientY };
  }, true);

  document.addEventListener('click', function (e) {
    var sl = e.target.closest && e.target.closest('.product-media-main .swiper-slide[data-gz-zoom]');
    if (!sl) return;
    if (klickStart && Math.abs(e.clientX - klickStart.x) + Math.abs(e.clientY - klickStart.y) > 10) return;
    if (!sammeln()) return;
    for (var i = 0; i < eintraege.length; i++) {
      if (eintraege[i].slide === sl) {
        e.preventDefault();
        e.stopImmediatePropagation();
        oeffnen(i, galerie.querySelector('.gz-zoom-lupe'));
        return;
      }
    }
  }, true);

  function lupeEinsetzen() {
    if (!sammeln() || galerie.querySelector('.gz-zoom-lupe')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gz-zoom-lupe';
    b.setAttribute('aria-label', T.oeffnen);
    b.innerHTML = ICON_LUPE;
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!sammeln()) return;
      var sw = galerie.swiper;
      var aktiv = sw ? sw.activeIndex : 0;
      var i = 0;
      for (var k = 0; k < eintraege.length; k++) {
        if (eintraege[k].swiperIndex === aktiv) { i = k; break; }
      }
      oeffnen(i, b);
    });
    galerie.appendChild(b);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lupeEinsetzen);
  } else {
    lupeEinsetzen();
  }
})();
